import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Form, InputNumber } from "antd";
import { debounce } from "lodash";
import { ARTWORK } from "../../../types";

const FontSize = ({ layer }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue(layer);
  }, [layer.id, layer.fontSize]);

  const handleChange = (_, values) => {
    dispatch({
      type: ARTWORK.SET_LAYER,
      payload: { ...layer, ...values },
    });
  };
  return (
    <Form form={form} onValuesChange={debounce(handleChange, 100)}>
      <Form.Item name="fontSize" style={{ margin: 0 }}>
        <InputNumber style={{ width: 65 }} disabled={layer.autofit} />
      </Form.Item>
    </Form>
  );
};

export default FontSize;
